import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Button, { BtnColor } from "../../../components/Button/Button";
import PulseLoader from "react-spinners/PulseLoader";
import { onSelectServiceChargeId } from "../../../store/Restaurant/actions";
import { useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const DiscountsList = ({ integration, items }) => {
    const { slug } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const queryClient = useQueryClient();

    const { restaurantId, integrationId, serviceChargeId, loading } =
        useSelector((state) => ({
            restaurantId: state.restaurant.restaurant_id,
            integrationId: state.restaurant.pos_selected?.integration_id,
            loading: state.restaurant.iiko_transport.discounts?.loading,
            serviceChargeId:
                state.restaurant.iiko_transport.selected?.service_charge_id,
        }));

    // send request to get updated store settings from backend
    const invalidateStore = () => queryClient.invalidateQueries(['store', slug]);

    const onSelectServiceCharge = (id) =>
        dispatch(onSelectServiceChargeId(restaurantId, integrationId, id, invalidateStore));

    return (
        <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
                <tr>
                    <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {t("Discount #")}
                    </th>
                    <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {t("Name")}
                    </th>
                    <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {t("Percent")}
                    </th>
                    <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                        {t("Sum")}
                    </th>
                    <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    ></th>
                </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
                {items?.map((item) => (
                    <tr key={item.id}>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="text-sm font-medium text-gray-900">
                                    {item.id}
                                </div>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="text-sm font-medium text-gray-900">
                                    {item.name}
                                </div>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="text-sm font-medium text-gray-900">
                                    {item.percent}
                                </div>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="text-sm font-medium text-gray-900">
                                    {item.sum}
                                </div>
                            </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                                <div className="text-sm font-medium text-gray-900">
                                    {item.percent < 0 ?(
                                        <>
                                            <Button
                                                color={item.external_uuid != serviceChargeId ? BtnColor.gold : BtnColor.gray}
                                                disabled={!integrationId}
                                                type={"button"}
                                                onClick={() =>
                                                    onSelectServiceCharge(item.id)
                                                }
                                            >
                                                {loading ? (
                                                    <PulseLoader
                                                        color="rgba(255, 255, 255, 1)"
                                                        loading={loading}
                                                        size={5}
                                                    />
                                                ) : (
                                                    item.external_uuid != serviceChargeId
                                                        ? t("select as service charge")
                                                        : t("selected as service charge")
                                                )}
                                            </Button>
                                        </>
                                    ):null}
                                </div>
                            </div>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default DiscountsList;
